import { styled } from "@stitches/react";

export const Preformatted = styled("pre", {
  margin: 0,
  fontFamily: "inherit",
  fontSize: "inherit",
  whiteSpace: "pre-wrap",
});
